<!--
  - Copyright (C) 2020. Archimedes Exhibitions GmbH,
  - Saarbrücker Str. 24, Berlin, Germany
  -
  - This file contains proprietary source code and confidential
  - information. Its contents may not be disclosed or distributed to
  - third parties unless prior specific permission by Archimedes
  - Exhibitions GmbH, Berlin, Germany is obtained in writing. This applies
  - to copies made in any form and using any medium. It applies to
  - partial as well as complete copies.
  -->

<template>
  <b-container class="py-4">
    <div class="py-4">
      <h1>{{ intro.header }}</h1>
      <p>
        {{ intro.text }}
      </p>
    </div>
    <hr>
    <b-row v-for="item in content" :key="item.title" class="py-4">
      <b-col cols="12" :lg="item.img_src ? 6 : 12">
        <h2>{{ item.title }}</h2>
        <p v-for="p in item.p" :key="p">
          {{ p }}
        </p>
        <b-alert :show="item.hasOwnProperty('example')"
                 variant="success" class="topic-example">
          <span v-html="item.example"></span>
        </b-alert>
      </b-col>
      <b-col cols="12" lg="6" v-if="item.img_src">
        <b-img thumbnail fluid  :src="getImgUrl(item.img_src)" :alt="item.img_alt"
               @click="modalShow = !modalShow; fullscreenImage = item.img_src"></b-img>
      </b-col>
    </b-row>
    <b-modal v-model="modalShow" centered hide-footer hide-header size="xl">
      <p>
        <b-img fluid v-if="fullscreenImage" :src="getImgUrl(fullscreenImage)"></b-img>
      </p>
    </b-modal>
  </b-container>
</template>

<script>

  import jPower from '../assets/docs/json/docs_power.json'
  import jDirectctrl from '../assets/docs/json/docs_directctrl.json'
  import jTimeline from '../assets/docs/json/docs_timeline.json'
  import jContent from '../assets/docs/json/docs_content.json'
  import jLayout from '../assets/docs/json/docs_bptc_layouts.json'
  import jSupport from '../assets/docs/json/docs_support.json'

  export default {
    name: 'Help',
    data () {
      return {
        docs: {
          'power-management': jPower,
          'direct-control': jDirectctrl,
          'scheduling': jTimeline,
          'cms': jContent,
          'bptc-exhibit-layout': jLayout,
          'service-support': jSupport
        },
        modalShow: false,
        fullscreenImage: null
      }
    },
    computed: {
      intro () {
        return this.docs[this.$route.params.section].intro
      },
      content () {
        return this.docs[this.$route.params.section].content
      }
    },
    methods: {
      getImgUrl (pic) {
        return require('../assets/docs/images/' + pic)
      }
    }
  }
</script>

<style scoped>
  .topic-example{
    font-size: 12px;
  }
</style>
